import { Layout } from './components/Layout';
import { Nav } from './components/Nav';
import { ToTop } from './components/ToTop';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Main } from './components/Main';
import { About } from './components/Main/About';
import { Price } from './components/Main/Price';
import { Vacancy } from './components/Main/Vacancy';
import { Contact } from './components/Main/Contact';
import { Social } from './components/Main/Social';
//import SimpleSlider from './Slick';

function App() {
  return (
    <Layout>
      <Nav />
      <Header />
      <Main>
        <About />
        <Price />
        <Vacancy />
        <Contact />
        <Social />
      </Main>
      <Footer />
      <ToTop />
    </Layout>
  );
}

export default App;
